import { render, staticRenderFns } from "./addFactory.vue?vue&type=template&id=3691d7aa"
import script from "./addFactory.vue?vue&type=script&lang=js"
export * from "./addFactory.vue?vue&type=script&lang=js"
import style0 from "./addFactory.vue?vue&type=style&index=0&id=3691d7aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports